export const FETCH_CONTACTS_COMMON_EMAILS = 'FETCH_CONTACTS_COMMON_EMAILS';
export const UPDATE_CONTACTS_COMMON_EMAILS = 'UPDATE_CONTACTS_COMMON_EMAILS'